module.exports = __webpack_public_path__ + "img/login-form.33bd32f6.png";